import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AdmissionOfficeDocState {
  tabsAdmissionsOffice: string;
  taskId: string;
  applicantId: number | null;
  /** Site URL from task/applicant — sent to qarshisu.net as `office_url` on document create. */
  officeUrl: string;
  /** Existing task attachment — sent on document create so backend replaces instead of spawning a new task. */
  attachedFile: string;
}

const initialState: AdmissionOfficeDocState = {
  tabsAdmissionsOffice: "",
  taskId: "",
  applicantId: null,
  officeUrl: "",
  attachedFile: "",
};

const admissionOfficeDocSlice = createSlice({
  name: "headerTabs",
  initialState,
  reducers: {
    setTabsAdmissionsOffice(state, action: PayloadAction<string>) {
      state.tabsAdmissionsOffice = action.payload;
    },
    setAdmissionFormContext(
      state,
      action: PayloadAction<
        Partial<{ taskId: string; applicantId: number | null; officeUrl: string; attachedFile: string }>
      >,
    ) {
      if (action.payload.taskId !== undefined) {
        state.taskId = action.payload.taskId;
      }
      if (action.payload.applicantId !== undefined) {
        state.applicantId = action.payload.applicantId;
      }
      if (action.payload.officeUrl !== undefined) {
        state.officeUrl = action.payload.officeUrl;
      }
      if (action.payload.attachedFile !== undefined) {
        state.attachedFile = action.payload.attachedFile;
      }
    },
    clearAdmissionFormContext(state) {
      state.taskId = "";
      state.applicantId = null;
      state.officeUrl = "";
      state.attachedFile = "";
    },
  },
});

export const { setTabsAdmissionsOffice, setAdmissionFormContext, clearAdmissionFormContext } =
  admissionOfficeDocSlice.actions;
export default admissionOfficeDocSlice.reducer;
